<template>
  <div>
    <el-dialog
      title="批量修改课程老师"
      :visible.sync="dialogVisible"
      @close="handleCloseDialog"
      width="440px"
    >
      <el-form
        ref="form"
        :rules="rules"
        label-width="120px"
        inline
        @submit.native.prevent
        size="mini"
        :model="form"
      >
        <el-form-item label="已选择学员:">
          <div>
            <span
              class="mwow-green"
              style="margin-right: 10px"
              v-for="(item, index) in selectedCourse"
              :key="index"
              >{{ item.student.name }}</span
            >
          </div>
        </el-form-item>
        <el-form-item label="需变更的课程老师:" prop="original_teacher_id">
          <el-select
            v-model="form.original_teacher_id"
            placeholder="请选择教师"
            clearable
            ref="origin-selector"
          >
            <el-option
              v-for="item in originStaffList"
              :key="item.staff_id"
              :label="item.name"
              :value="item.staff_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="变更后的课程老师:" prop="target_teacher_id">
          <el-select
            v-model="form.target_teacher_id"
            placeholder="请选择教师"
            clearable
            @focus="getAfterStaffList('')"
            filterable
            :filter-method="getAfterStaffList"
            ref="target-selector"
          >
            <el-option
              v-for="item in afterStaffList"
              :key="item.staff_id"
              :label="item.name"
              :value="item.staff_id"
              :disabled="item.staff_id === form.original_teacher_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-tag type="warning" style="margin-bottom: 24px"
        >温馨提示：变更成功后，变更后的课程老师会覆盖变更前的课程老师</el-tag
      >
      <div style="text-align: right">
        <div
          class="mwow-button-filled"
          @click="handleCloseDialog"
          style="margin-right: 12px"
        >
          取消
        </div>
        <div class="mwow-button-filled success" @click="handleConfirm">
          确定
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { staffList } from "@/api/globalSearch";
import { multiChangeCourseTeacherApi } from "@/api/teacherManage";

export default {
  props: ["visible", "origin-data"],
  data() {
    return {
      form: {
        account_ids: [],
        original_teacher_id: "",
        target_teacher_id: "",
      },
      selectedCourse: [],
      originStaffList: [],
      afterStaffList: [],
      dialogVisible: false,
      rules: {
        original_teacher_id: [
          {
            required: true,
            message: "请选择需变更的课程老师",
            trigger: "change",
          },
        ],
        target_teacher_id: [
          {
            required: true,
            message: "请选择变更后的课程老师",
            trigger: "change",
          },
        ],
      },
    };
  },
  watch: {
    visible: {
      handler(n) {
        if (n) {
          let originRes = [];
          this.originData.map((c) => {
            if (
              !originRes.find((it) => {
                return it.student_id === c.student_id;
              })
            ) {
              originRes.push(c);
            }
          });
          this.selectedCourse = originRes;
          this.dialogVisible = n;
          this.getOriginStaffList();
        } else {
          this.form = {
            account_ids: [],
            original_teacher_id: "",
            target_teacher_id: "",
          };
          this.originStaffList = [];
          this.afterStaffList = [];
        }
      },
    },
  },
  methods: {
    getOriginStaffList() {
      let res = [];
      this.originData.map((c) => {
        if (c.relation_teacher_list) {
          c.relation_teacher_list.map((t) => {
            if (
              !res.find((it) => {
                return it.staff_id === t.staff_id;
              })
            ) {
              res.push(t);
            }
          });
        }
      });
      this.originStaffList = res;
    },
    getAfterStaffList(v) {
      staffList({
        page: 1,
        page_size: 100,
        status: 1,
        key_word: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.afterStaffList = res.data.list;
        }
      });
    },
    handleConfirm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$confirm(
            `确认把选中学员关联的“${this.$refs["origin-selector"].selectedLabel}”课程老师变更为“${this.$refs["target-selector"].selectedLabel}”?`,
            `批量修改学员课程老师`,
            {
              confirmButtonText: "确定",
              confirmButtonClass: "mwow-button-filled success mini",
              cancelButtonText: "取消",
              cancelButtonClass: "mwow-button-filled mini",
              type: "warning",
            }
          )
            .then(() => {
              let account_ids = this.selectedCourse.map((c) => {
                return c.account_id;
              });
              let params = {
                student_course_account_ids: [...new Set(account_ids)],
                original_teacher_id: this.form.original_teacher_id,
                target_teacher_id: this.form.target_teacher_id,
              };
              multiChangeCourseTeacherApi(params).then((res) => {
                this.dialogVisible = false;
                this.$emit("change");
                this.$message({
                  type: "success",
                  message: "修改成功",
                });
              });
            })
            .catch(() => {});
        }
      });
    },
    handleCloseDialog() {
      this.dialogVisible = false;
      this.$emit("update:visible", false);
    },
  },
};
</script>
<style lang="scss" scoped></style>
